/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driver_Order_SubtitleInputs */

const vi_driver_order_subtitle = /** @type {(inputs: Driver_Order_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các đơn đã xuất kho chưa có tài xế`)
};

/**

* @param {Driver_Order_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const driver_order_subtitle = /** @type {((inputs?: Driver_Order_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driver_Order_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driver_order_subtitle(inputs)
});